import axios from 'axios';

const accounting_settings_url = 'accounting-settings/';

export default {
    async getAccountingSettings(){
        const url = accounting_settings_url + '1/';
        return axios.get(url)
        .then((response) => {
            return response.data;
        }).catch(err => {
            console.log(err.response.data);
        });
    },
}